// Pharmacist picklist ordering helpers.
//
// The actual "pickup priority" sort (earliest start date -> Delhi NCR -> earliest
// order date) now lives server-side, in pillup-api's classes/UserOrder/Functions.js
// (getAdmin's PICKUP_PRIORITY_ORDER_BY branch) -- see
// src/v2/pharmacy/pages/orders/sortPresets.js for how the four sort presets ask for it
// via orderBy/order query params. It used to be a client-side re-sort here
// (`sortByPriority`/`timeOf`, removed), but that only ever reordered the current
// 20-row page -- it could never surface the true most-urgent order across the whole
// filtered set if that order happened to land on a different page. Moving it
// server-side, ordering before pagination, fixed that.
//
// What's left here are the two things that are still genuinely client-side concerns:
// the NCR badge (a rendering decision, not a sort) and the Days Left column's own
// display math.

/** Cities/states that count as the Delhi NCR dispatch zone. */
const NCR_MATCHES = ["delhi", "new delhi", "noida", "gurugram", "gurgaon", "ghaziabad", "faridabad"];

/** A row is NCR if either its city or its state names an NCR location. */
export function isDelhiNcr(row) {
    const haystack = `${row?.city || ""} ${row?.state || ""}`.toLowerCase();
    return NCR_MATCHES.some((match) => haystack.includes(match));
}

/**
 * Whole days from today until `endDate`. Negative once the date has passed.
 *
 * Deliberately NOT clamped at zero. The prototype had two different functions here —
 * one clamped, one not — so the same column displayed and exported different numbers.
 * An order that ran out nine days ago is more urgent than one running out tomorrow, and
 * clamping hides exactly that.
 */
export function daysLeftUntil(endDate) {
    if (!endDate) return null;
    const end = new Date(endDate);
    if (Number.isNaN(end.getTime())) return null;
    return Math.ceil((end.getTime() - Date.now()) / 86400000);
}
